import { LISTING_STATUS, LISTING_TYPE } from '@constants/property'
import { formatDate } from '@lib/date'
import AddToCalendar from '@global/AddToCalendar'
import StatementOfInformation from '../StatementOfInformation'
import React from 'react'
import { formatPrice } from '@global/ListingCard/ListingPrice'

import * as S from './PropertyPrice.styled'

const DEFAULT_DATE_FORMAT = 'EE do MMMM, h:mm b'

const Info = ({ label, value, highlight }) => {
  return (
    <S.Info highlight={highlight}>
      <S.InfoLabel>{label}</S.InfoLabel>
      <S.InfoValue>
        {value || <React.Fragment>&nbsp;</React.Fragment>}
      </S.InfoValue>
    </S.Info>
  )
}

const ListingPriceInfo = ({ listing }) => {
  return (
    <React.Fragment>
      {listing.status !== LISTING_STATUS.SOLD &&
        listing.status !== LISTING_STATUS.LEASED && (
          <Info
            label={
              (listing.listingType === LISTING_TYPE.SALE ||
                (!listing.listingType && listing.offmarket)) &&
              listing.status !== LISTING_STATUS.SOLD
                ? 'Price Guide'
                : 'Price'
            }
            value={
              listing.priceGuide !== 'Contact Agent'
                ? listing.priceGuide
                : listing.isMultiple
                ? `${formatPrice(listing.price_range_min)} - ${formatPrice(
                    listing.price_range_max
                  )}`
                : 'Contact Agent'
            }
          />
        )}
      {(listing.status === LISTING_STATUS.SOLD ||
        listing.status === LISTING_STATUS.LEASED) && (
        <React.Fragment>
          {listing.soldDetails_date && (
            <Info
              label={listing.status}
              value={
                <>
                  {/* Sold price on mobile */}
                  {listing.status === LISTING_STATUS.SOLD && (
                    <span className='sold-price mobile'>
                      {listing.soldDetails_price_display &&
                        Intl.NumberFormat('en-au', {
                          style: 'currency',
                          currency: 'AUD',
                          maximumFractionDigits: 0,
                        }).format(listing.soldDetails_price)}
                    </span>
                  )}
                  <span className='sold-date'>
                    {formatDate(
                      new Date(listing.soldDetails_date),
                      'EE do MMMM yyyy'
                    )}
                  </span>
                </>
              }
            />
          )}
          {/* Hide this info on mobile */}
          {listing.status === LISTING_STATUS.SOLD &&
            listing.soldDetails_price_display && (
              <Info
                label={<React.Fragment>&nbsp;</React.Fragment>}
                value={
                  <span className='sold-price'>
                    {listing.soldDetails_price_display &&
                      Intl.NumberFormat('en-au', {
                        style: 'currency',
                        currency: 'AUD',
                        maximumFractionDigits: 0,
                      }).format(listing.soldDetails_price)}
                  </span>
                }
                highlight
              />
            )}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

const PropertyPrice = ({ listing }) => {
  if (listing.listing) listing = listing.listing

  const isDisplayAuction =
    listing.auction_date &&
    listing.status !== LISTING_STATUS.SOLD &&
    !listing.underOffer

  const isSaleBySetDate =
    listing.listingType === LISTING_TYPE.SALE &&
    listing.salebySetDate &&
    listing.status !== LISTING_STATUS.SOLD

  return (
    <S.InfoGroup>
      <S.PriceInfo>
        {listing.status !== LISTING_STATUS.SOLD &&
          listing.status !== LISTING_STATUS.LEASED && (
            <React.Fragment>
              {listing.underOffer ? (
                <Info label='Under Offer' />
              ) : // auction
              isDisplayAuction ? (
                <Info
                  label={`${listing.onlineauctions ? 'Online ' : ''}Auction`}
                  value={formatDate(
                    new Date(listing.auction_date),
                    DEFAULT_DATE_FORMAT
                  )}
                />
              ) : // for sale
              listing.listingType === LISTING_TYPE.SALE ? (
                listing.salebySetDate ? (
                  <Info
                    label={
                      <React.Fragment>
                        Sale by SET DATE<sup>&reg;</sup>
                      </React.Fragment>
                    }
                    value={formatDate(
                      new Date(listing.salebySetDate),
                      DEFAULT_DATE_FORMAT
                    )}
                  />
                ) : (
                  <Info label='For Sale' />
                )
              ) : // for lease
              listing.listingType === LISTING_TYPE.LEASE ? (
                <Info
                  label='For Lease'
                  value={
                    listing.dateAvailable === 'Now'
                      ? 'Available Now'
                      : `Available ${formatDate(
                          new Date(listing.dateAvailable),
                          'EE do MMMM'
                        )}`
                  }
                />
              ) : null}
            </React.Fragment>
          )}
        <ListingPriceInfo listing={listing} />
      </S.PriceInfo>
      {(isDisplayAuction || listing.status !== LISTING_STATUS.SOLD) && (
        <S.OtherInfo>
          {isDisplayAuction ? (
            <AddToCalendar
              text='Add to calendar'
              title={`Auction | ${listing.address}`}
              type='Auction'
              tz={listing.timezone}
              property={listing}
              start={listing.auction_date}
            />
          ) : isSaleBySetDate ? (
            <AddToCalendar
              text='Add to calendar'
              title={`Sale by Set Date Closing | ${listing.address}`}
              type='For Sale'
              tz={listing.timezone}
              property={listing}
              start={listing.salebySetDate}
            />
          ) : null}
          {listing.status !== LISTING_STATUS.SOLD && (
            <StatementOfInformation documents={listing.documents} />
          )}
        </S.OtherInfo>
      )}
    </S.InfoGroup>
  )
}

export default PropertyPrice
